import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/',
      name: 'mainPage',
      component: resolve => require(['@/pages/mainPage/mainPage.vue'], resolve)
    },
    {
      path: '/operateAccount',
      name: 'operateAccount',
      component: resolve => require(['@/pages/operateAccount/operateAccount.vue'], resolve)
    },
    {
      path: '/privateLetter',
      name: 'privateLetter',
      component: resolve => require(['@/pages/privateLetter/index.vue'], resolve)
    },
    {
      path: '/tags',
      name: 'tags',
      component:  () => import('./pages/tags/index.vue')
    }
  ]
});
